import React from "react"
import { Link } from "gatsby"
import Layout from "../components/layout"
import SEO from "../components/seo"
import { Helmet } from "react-helmet"
import ContactForm from "../components/contactForm"
import { Obfuscate } from "@south-paw/react-obfuscate-ts"
import ImageContact from "../components/imageContact"
import styled from "@emotion/styled"
import { css } from "@emotion/react"
import { FaCalendarCheck, FaPhone, FaEnvelope } from "react-icons/fa"

const ContactPage = () => (
  <Layout pathEn="/en/contact/">
    <SEO
      title="Contact / Accès / Rendez-vous - Dr Philippe Roure"
      description="Poser une question, prendre rendez-vous pour une consulation ou horaires du cabinet du Dr Philippe Roure "
    />
    <Helmet>
      <link
        rel="alternate"
        hreflang="en"
        href={`https://www.docteurphilipperoure.com/en/contact/`}
      />
    </Helmet>
    <ImageContact />
    <WrapperTitle>
      <Breadcrumb>
        <Link to="/">Accueil </Link>
      </Breadcrumb>
      <H1>Contact / Accès / Rendez-vous</H1>
      <p className="intro">
        Pour poser une question au Dr Roure ou pour prendre rendez-vous, vous
        pouvez contacter le secrétariat par téléphone ou au travers du
        formulaire de contact ci-dessous. La prise de rendez-vous est également
        possible sur Doctolib.
      </p>
    </WrapperTitle>

    <Wrapper>
      <Row
        id="rdv"
        css={css`
          padding-top: 45px;
          margin-bottom: 20px;
        `}
      >
        <Col1>
          <Title>Prendre RDV</Title>
          <P>
            Seule une partie de l'agenda est accessible sur Doctolib,
            appelez-nous pour connaitre l'ensemble des RDV disponibles.
          </P>
          <p>&nbsp;</p>
        </Col1>
        <Col2>
          <p>
            <a
              href="https://www.doctolib.fr/chirurgien-orthopediste/paris/philippe-roure"
              targer="_blank"
              rel="noreferrer noopener"
            >
              <FaCalendarCheck
                css={css`
                  transform: translateY(1px);
                `}
              />{" "}
              Prendre rendez-vous sur Doctolib (au cabinet ou en
              vidéo-consultation)
            </a>
          </p>
          <p>
            <strong>
              Espace Médical Vauban <span>(Virginie)</span> :
            </strong>{" "}
            <FaPhone
              css={css`
                transform: translateY(1px);
              `}
            />{" "}
            <a href="tel:+33153598809">01 53 59 88 09</a> |
            <FaEnvelope
              css={css`
                transform: translateY(2px);
                margin-left: 4px;
                margin-right: 2px;
              `}
            />{" "}
            <Obfuscate
              email="assistante.drroure.meyer@gmail.com"
              target="_blank"
            >
              Écrire un message
            </Obfuscate>
          </p>
          <p>
            <strong>
              Clinique du Sport <span>(Paula)</span>
            </strong>{" "}
            :{" "}
            <FaPhone
              css={css`
                transform: translateY(1px);
              `}
            />{" "}
            <a href="tel:+33186867505">01 86 86 75 05</a> |
            <FaEnvelope
              css={css`
                transform: translateY(2px);
                margin-left: 4px;
                margin-right: 2px;
              `}
            />{" "}
            <Obfuscate email="paula.carones@wanadoo.fr" target="_blank">
              Écrire un message
            </Obfuscate>
          </p>
        </Col2>
      </Row>
      <Row>
        <div>
          <Title>Téléconsultation</Title>
          <p>
            Si vous ne souhaitez pas vous déplacer, ou si vous habitez loin, la
            vidéo-consultation avec le Docteur Roure est accessible via{" "}
            <a
              href="https://www.doctolib.fr/chirurgien-orthopediste/paris/philippe-roure"
              target="_blank"
              rel="noreferrer noopener"
            >
              Doctolib
            </a>
            .
          </p>
          <p>
            <strong>
              Aucune consultation médicale ne pourra vous être donnée par
              téléphone ou e-mail
            </strong>
            . Un rendez-vous vous sera en revanche proposé, si vous le
            souhaitez, dans les meilleurs délais avec le docteur Philippe Roure.
          </p>
        </div>
      </Row>
      <ContactForm
        css={css`
          max-width: 400px;
          margin-top: -20px;
        `}
        about="les interventions pratiquées par le Dr Roure"
        title="Page Contact"
      />

      <Row
        css={css`
          margin-bottom: 20px;
          margin-top: 30px;
        `}
      >
        <Col1>
          <Title>Accès / Horaires</Title>
        </Col1>
        <Col2>
          <P>
            Les consultations se déroulent à l'
            <strong>Espace Médical Vauban</strong> les mardis et vendredis
            après-midis.
          </P>

          <P>
            À la <strong>Clinique du sport</strong>, les consultations ont lieu
            les lundis après-midis et les vendredi matin.
          </P>
          <P>
            Pour toute précision sur les horaires, les autres lieux ou jours de
            consultation, contacter Virginie ou Paula.
          </P>
        </Col2>
      </Row>
      <Row>
        <Col1
          css={css`
            text-align: center;
          `}
        >
          <H3>Espace Medical Vauban</H3>
          <P>
            2A, Avenue de ségur
            <br />
            75007 Paris
            <br />
            Métro: Ecole Militaire (ligne 8),
            <br />
            St François Xavier (ligne 13)
            <br />
            Stationnement aisé en voiture dans la contre allée au pied du
            cabinet
          </P>
        </Col1>
        <Col2>
          {" "}
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d21002.235330161733!2d2.302042746736518!3d48.85288200559685!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xf1a966571b85f101!2sEspace+M%C3%A9dical+Vauban!5e0!3m2!1sfr!2sus!4v1559670912011!5m2!1sfr!2sus"
            width="100%"
            height="250"
            frameborder="0"
            allowfullscreen
            css={css``}
            title="Plan d'accés vers l'Espace Medical Vauban, Paris 7"
          />
        </Col2>
      </Row>
      <Row>
        <Col1
          css={css`
            text-align: center;
          `}
        >
          <H3 css={css``}>Clinique du sport</H3>
          <P>
            36, Boulevard Saint Marcel
            <br />
            75005 Paris
            <br />
            Métro: Saint Marcel (ligne 5),
            <br />
            Censier Daubenton (ligne 7)
            <br />
            Parking ouvert au public rue de l’Essai à côté de la clinique.
          </P>
        </Col1>
        <Col2>
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d21008.082826613543!2d2.3491977467611225!3d48.83894120572731!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x3ed01a548cf442fd!2sClinique+du+Sport+-+Ramsay+G%C3%A9n%C3%A9rale+de+Sant%C3%A9!5e0!3m2!1sfr!2sus!4v1559670535208!5m2!1sfr!2sus"
            width="100%"
            height="250"
            frameborder="0"
            allowfullscreen
            title="Plan d'accès vers la Clinique du sport Paris 5"
          />
        </Col2>
      </Row>
      <Row>
        <div>
          <Title>En cas d'urgence médicale</Title>

          <P>Appeler mon cabinet ou contacter le SAMU : 15</P>
        </div>
      </Row>
    </Wrapper>
  </Layout>
)

export default ContactPage

const WrapperTitle = styled.div`
  background-color: white;
  width: 78%;
  margin: 0 auto;
  border-radius: 7px;
  padding: 1.5em 2em 0.9em;
  margin-bottom: 45px;
  box-shadow: rgba(0, 0, 0, 0.05) 0px 1px 7px;
  @media (max-width: 1024px) {
    width: 100%;
    box-sizing: border-box;
    padding: 1em 1em 0.5em;
    margin-bottom: 25px;
  }
`
const Breadcrumb = styled.div`
  color: #e6ae48;
  text-align: center;
  font-size: 0.9em;
  line-height: 1em;
  font-weight: 400;
  a {
    color: #919090;
    text-decoration: none;
  }
  @media (max-width: 678px) {
    font-size: 0.87em;
    margin-bottom: 10px;
  }
`

const H1 = styled.h1`
  font-size: 2.1em;
  @media (max-width: 678px) {
    font-size: 1.82em;
    line-height: 1.1em;
  }
`

const Wrapper = styled.div`
  background-color: white;
  border-radius: 5px;
  margin: 0.5em auto 0.5em;
  padding: 0.25em 2em 1em 2em;
  box-shadow: rgba(0, 0, 0, 0.05) 0px 1px 7px;
  @media (max-width: 1024px) {
    padding: 0em 1em 0.5em;
  }
`
const Row = styled.div`
  display: flex;
  margin: 15px 0 15px;
  clear: both;
  @media (max-width: 678px) {
    display: block;
  }
`

const Col1 = styled.div`
  flex: 34%;
`

const Col2 = styled.div`
  flex: 66%;
  padding-left: 17px;
  a {
    text-decoration: none;
    border: none;
  }
  p {
    margin-bottom: 15px;
  }
  @media (max-width: 678px) {
    padding: 0;
    font-size: 0.96em;
    span {
      display: none;
    }
  }
`

const Title = styled.h2`
  margin-bottom: 0.5em;
  margin-top: 0;
  font-weight: 600;
  color: rgba(44, 44, 44, 0.96);
  font-size: 1.45em;
  letter-spacing: 0.035em;
  text-transform: uppercase;
  font-family: Raleway, "Times new roman", serif;
`

const P = styled.p`
  font-size: 0.95em;
  line-height: 1.55em;
`

const H3 = styled.h3`
  margin-top: 40px;
`
